import { render, staticRenderFns } from "./PainelCgirci.vue?vue&type=template&id=b8d955ba"
import script from "./PainelCgirci.vue?vue&type=script&lang=js"
export * from "./PainelCgirci.vue?vue&type=script&lang=js"
import style0 from "./PainelCgirci.vue?vue&type=style&index=0&id=b8d955ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports